import { styled } from '@shared/ui/styled';

const Skel = styled('span', { shouldForwardProp: p => !['$w', '$h'].includes(p) })(
  ({ $w, $h }) => ({
    display: 'inline-block',
    width: $w ?? '100%',
    height: $h ?? 12,
    borderRadius: 6,
    background:
      'linear-gradient(90deg, var(--qhs-border) 0%, rgba(229,231,235,0.4) 50%, var(--qhs-border) 100%)',
    backgroundSize: '200% 100%',
    animation: 'qhsInfoPaneShimmer 1.4s linear infinite',
    '@keyframes qhsInfoPaneShimmer': {
      '0%': { backgroundPosition: '200% 0' },
      '100%': { backgroundPosition: '-200% 0' },
    },
  })
);

const SectionTitle = styled('div')({
  padding: '14px 20px 8px',
  fontFamily: 'var(--qhs-font-head)',
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: 1.4,
  textTransform: 'uppercase',
  color: 'var(--qhs-text-3)',
});

const Row = styled('div')({
  display: 'grid',
  gridTemplateColumns: '110px 1fr auto',
  gap: 12,
  padding: '11px 20px',
});

/**
 * Skeleton-shimmer body for the InfoPane Patient sub-page. Shown only
 * after the 1.5 s deferred-loader timer (in PatientPane) elapses, so
 * fast responses skip the skeleton entirely.
 */
const SkeletonBody = () => (
  <div>
    <div
      style={{
        padding: '20px 20px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
      }}
    >
      <Skel $w={52} $h={52} style={{ borderRadius: '50%' }} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skel $w='60%' $h={20} />
        <Skel $w='40%' $h={12} />
      </div>
    </div>
    {['IDENTIFICATION', 'CONTACT'].map(title => (
      <div key={title}>
        <SectionTitle>{title}</SectionTitle>
        {[70, 50, 65, 40].map(w => (
          <Row key={`${title}-${w}`}>
            <Skel $w={80} />
            <Skel $w={`${w}%`} />
            <span />
          </Row>
        ))}
      </div>
    ))}
  </div>
);

export default SkeletonBody;
